module.exports = __webpack_public_path__ + "img/02_maska_krug_1.cee9c55.svg";